import React from "react";
import SEO from "@/components/SEO";
import ServiceAreasSection from "@/components/ServiceAreasSection";
import QuoteSection from "@/components/QuoteSection";
import FinalCTA from "@/components/FinalCTA";
import { COMPANY } from "@/data/site";
import { MapPin, Phone } from "lucide-react";

const ServiceAreasPage = () => {
  return (
    <>
      <SEO
        title="Wyoming Moving Service Areas | Casper, Mills, Cheyenne & More"
        description="Crosstown Movers provides professional moving services across Wyoming: Casper, Mills, Evansville, Bar Nunn, Glenrock, Laramie, Riverton, Cheyenne. Call (307) 265-8291."
        path="/service-areas"
      />
      <section className="py-20 md:py-28 bg-[var(--ct-primary)] text-white">
        <div className="section-container">
          <div className="label-xs text-[var(--ct-secondary)] mb-3">Where We Move</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>
            Wyoming Moving Service Areas
          </h1>
          <p className="mt-5 text-white/80 max-w-3xl text-lg">
            Crosstown Movers is proud to serve homes and businesses across central Wyoming. Whether you're
            moving within Casper or relocating from Mills to Cheyenne, our experienced crews are ready.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="/#quote" className="btn-primary">Get a Free Quote</a>
            <a href={`tel:${COMPANY.phoneTel}`} className="btn-outline !text-white !border-white hover:!bg-white hover:!text-[var(--ct-primary)]">
              <Phone className="w-4 h-4" /> {COMPANY.phone}
            </a>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="section-container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {COMPANY.serviceAreas.map((area) => (
              <div key={area} className="p-6 rounded-2xl bg-[var(--ct-bg)] border border-[var(--ct-border)] hover:-translate-y-1 hover:shadow-lg transition-all" data-testid={`area-card-${area}`}>
                <MapPin className="w-6 h-6 text-[var(--ct-secondary)]" />
                <h3 className="mt-3 text-xl font-semibold text-[var(--ct-primary)]" style={{ fontFamily: "Outfit" }}>{area}</h3>
                <p className="mt-2 text-sm text-[var(--ct-text-muted)]">
                  Professional residential and commercial moving in {area.split(",")[0]}.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ServiceAreasSection />
      <QuoteSection />
      <FinalCTA />
    </>
  );
};

export default ServiceAreasPage;
